import { DataTable } from "mantine-datatable";
import React, { useEffect, useState } from "react";
import CustomPagination from "../../components/Layouts/CustomPagination";
import { AiFillEye } from "react-icons/ai";
import { FiBell, FiRefreshCw, FiSend } from "react-icons/fi";
import Swal from "sweetalert2";
import DropdownCustom from "../../components/DropdownCustom";
import CountriesJSON from "../../components/countries.json";
import moment from "moment";
import UserDetailsService from "../../service/userdetails.service";
import DashboardService from "../../service/dashboard.service";
import NotifyService from "../../service/notify.service";
// import { truncate } from "fs";

function UserDetails() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  // const [mobileNo, setMobileNo] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [page, setPage] = useState(1);
  const PAGE_SIZES = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  //   const [status, setStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [date, setDate] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [isOnline, setIsOnline] = useState("");
  const [selectedMCC, setSelectedMCC] = useState("");
  const [selectedMNC, setSelectedMNC] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [mncData, setMncData] = useState([]);
  const [mccData, setMccData] = useState([]);
  const [isFirst, setIsFirst] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [debouncedMobile, setDebouncedMobile] = useState(""); // mobileNumber, debounced for the fetch
  const [verified, setVerified] = useState(""); // "", "true", "false"
  const [fromSim, setFromSim] = useState(""); // "", "true", "false" — number read from SIM vs typed
  const [confirmState, setConfirmState] = useState(null); // custom confirm modal state
  const [bulkBusy, setBulkBusy] = useState(false);
  const [crossBusy, setCrossBusy] = useState(false);

  const getMncMc = async () => {
    try {
      const mccDataResponse = await UserDetailsService.getMncMcc(true);

      const mccDataResponseAll = mccDataResponse.data.apiresponse.data;

      const options = [];

      options.push({ value: "", label: "All" });

      mccDataResponseAll.forEach((item) => {
        if (item !== null) {
          options.push({
            value: item,
            label: item,
          });
        }
      });
      setMncData(options);

      const mncDataResponse = await UserDetailsService.getMncMcc(false);

      const mncDataResponseAll = mncDataResponse.data.apiresponse.data;
      // const optionsMNC = mncDataResponseAll.map((item) => ({
      //   value: item === null ? null : item,
      //   label: item === null ? "All" : item,
      // }));

      const optionsMNC = [];

      optionsMNC.push({ value: "", label: "All" });

      mncDataResponseAll.forEach((item) => {
        if (item !== null) {
          optionsMNC.push({
            value: item,
            label: item,
          });
        }
      });
      setMccData(optionsMNC);
    } catch (error) {
      showMessage(error.message, "error");
    }
  };

  useEffect(() => {
    getMncMc();
  }, []);

  const showMessage = (msg, type) => {
    Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      showCloseButton: true,
      timer: 2800,
      timerProgressBar: true,
      customClass: { popup: "rounded-lg shadow-lg !p-3 text-sm" },
    }).fire({ icon: type === "danger" ? "error" : type || "info", title: msg });
  };

  const handleChange = (type, page) => {
    const total = totalData / pageSize;
    const newPage = Math.ceil(total);
    if (type === "Next") {
      if (page !== newPage) {
        setPage(page + 1);
      }
    } else if (type === "Previous") {
      if (page !== 1) {
        setPage(page - 1);
      }
    } else if (type === "First") {
      if (page !== 1) {
        setPage(1);
      }
    } else if (type === "Last") {
      if (page !== newPage) {
        setPage(newPage);
      }
    } else {
      setPage(page);
    }
  };

  const getAllUser = async () => {
    setIsFirst(true);
    if (isFirst) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }

    // Installation-date range, whole days in the viewer's timezone.
    const valid = (d) => d && d !== "Invalid date";
    const formattedDate = {
      from: valid(date) ? moment(date, "YYYY-MM-DD").startOf("day").valueOf() : "",
      to: valid(dateTo) ? moment(dateTo, "YYYY-MM-DD").endOf("day").valueOf() : "",
    };

    try {
      const response = await UserDetailsService.getAllUser(
        // mobileNo,
        selectedCountry,
        formattedDate,
        isOnline,
        page,
        pageSize,
        String(selectedMNC),
        String(selectedMCC),
        debouncedMobile,
        verified,
        fromSim
      );

      setData(response.data.apiresponse.data.user);
      setTotalData(response.data.apiresponse.data.total);
    } catch (error) {
      showMessage(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  // Debounce the mobile-number text filter so typing doesn't fire a fetch (and restart the poll)
  // on every keystroke.
  useEffect(() => {
    const t = setTimeout(() => setDebouncedMobile(mobileNumber), 400);
    return () => clearTimeout(t);
  }, [mobileNumber]);

  // Any filter change starts again from page 1 (staying on page 2 of a shorter result showed
  // an empty table).
  useEffect(() => {
    setPage(1);
  }, [selectedCountry, selectedMCC, selectedMNC, isOnline, verified, fromSim, date, dateTo, debouncedMobile]);

  // Safety net: if the list shrinks under the current page, go to the last page.
  useEffect(() => {
    const last = Math.max(1, Math.ceil(totalData / pageSize));
    if (page > last) setPage(last);
  }, [totalData, pageSize, page]);

  useEffect(() => {
    getAllUser();
    const intervalId = setInterval(() => {
      setIsFirst(false);
      getAllUser();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [selectedCountry, selectedMCC, selectedMNC, isOnline, verified, fromSim, date, dateTo, debouncedMobile, page, pageSize]);

  // Bulk-wake every device matching the CURRENT filters (reuses the same filter state as the
  // list). Maps them to the /admin/notify-filter API, then refreshes so you SEE who came online.
  const bulkNotify = async () => {
    const body = {};
    if (selectedCountry) body.country = selectedCountry;
    if (selectedMCC) body.mcc = String(selectedMCC);
    if (selectedMNC) body.mnc = String(selectedMNC);
    if (isOnline === "true" || isOnline === "false") body.online = isOnline === "true";
    if (verified === "true" || verified === "false") body.verified = verified === "true";
    if (mobileNumber) body.mobileNumber = Number(mobileNumber);

    const confirm = await confirmDialog({
      title: "Bulk notify?",
      text:
        Object.keys(body).length === 0
          ? "No filters set — this wakes EVERY device (up to 500). Continue?"
          : `Wake devices matching: ${JSON.stringify(body)}`,
      confirmButtonText: "Notify",
    });
    if (!confirm.isConfirmed) return;

    setBulkBusy(true);
    try {
      const res = await NotifyService.notifyByFilter(body);
      const d = res?.data?.apiresponse?.data || {};
      toastMsg("success", `Woke ${d.notified ?? 0} device(s)`);
      setIsFirst(false);
      getAllUser(); // refresh — online devices will flip as they answer
    } catch (e) {
      showMessage("Bulk notify failed", "error");
    } finally {
      setBulkBusy(false);
    }
  };

  const handleDataPerPage = (e) => {
    setPageSize(Number(e.target.value) || 10);
    setPage(1); // reset to first page so the range can't go out of bounds
  };

  const handleDateChange = (e) => {
    setDate(e.target.value ? moment(e.target.value).format("YYYY-MM-DD") : "");
    setPage(1);
  };
  const handleDateToChange = (e) => {
    setDateTo(e.target.value ? moment(e.target.value).format("YYYY-MM-DD") : "");
    setPage(1);
  };
  //   const handleClick = (selectedDate) => {
  //     const date = moment(selectedDate.target.value).format("YYYY-MM-DD");
  //     setDate(date);
  //   };

  const handleClearFilters = () => {
    setIsOnline("");
    setVerified("");
    setFromSim("");
    setSelectedCountry("");
    setSelectedMCC("");
    setSelectedMNC("");
    setMobileNumber("");
    setDate("");
    setDateTo("");
    setSelectedStatus("");
    setPage(1);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await UserDetailsService.getCountry();
        const countries = response.data.apiresponse.data;
        const options = countries.map((item) => ({
          value: item,
          label: item,
        }));

        const newObject = [{ value: "", label: "All" }, ...options];

        setCountryOptions(newObject);
        // setCountryOptions(options);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const sendNotification = async (id) => {
    try {
      const response = await DashboardService.dashboardPushNotification([id]);
      toastMsg("success", "Notification sent");
      getAllUser();
    } catch (error) {
      toastMsg("danger", error.message || "Failed to send notification");
    }
  };

  // ---- Admin cross-check (rescue) ----
  // One clean toast everywhere: top-right, auto-dismiss with a progress bar, icon by type
  // ("danger" -> the error icon). No solid colour-block popups.
  const toastMsg = (type, title) =>
    Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      showCloseButton: true,
      timer: 2800,
      timerProgressBar: true,
      customClass: { popup: "rounded-lg shadow-lg !p-3 text-sm" },
    }).fire({ icon: type === "danger" ? "error" : type, title });

  // Custom confirm dialog (NOT SweetAlert) — a delicate, professional card rendered at the bottom
  // of this component. Promise-based so callers keep using:
  //   const ok = await confirmDialog({...}); if (!ok.isConfirmed) return;
  const confirmDialog = (opts = {}) =>
    new Promise((resolve) => setConfirmState({ ...opts, resolve }));

  const closeConfirm = (isConfirmed) => {
    if (confirmState) confirmState.resolve({ isConfirmed });
    setConfirmState(null);
  };

  const crossFilters = () => {
    const f = {};
    if (selectedCountry) f.country = selectedCountry;
    if (selectedMCC) f.mcc = String(selectedMCC);
    if (selectedMNC) f.mnc = String(selectedMNC);
    if (isOnline === "true" || isOnline === "false") f.isOnline = isOnline;
    if (mobileNumber) f.mobileNumber = Number(mobileNumber);
    return f;
  };

  // Cross one unverified+offline user: one gateway SMS; the row turns Verified when the phone reports it.
  const crossOne = async (row) => {
    const ok = await confirmDialog({
      title: "Cross-check?",
      text: `Send a verification SMS to ${row.mobileNumber}?`,
      note: "1 gateway SMS",
      confirmButtonText: "Send",
      danger: true,
    });
    if (!ok.isConfirmed) return;
    try {
      await UserDetailsService.crossUser(row.id);
      toastMsg("success", `Cross sent to ${row.mobileNumber}`);
      getAllUser();
    } catch (e) {
      toastMsg("danger", e?.response?.data?.apierror?.message || "Cross failed");
    }
  };

  // Remote self-loop (RSL): free, device-sent re-verification. Try this before the paid Cross.
  const selfLoopOne = async (row) => {
    const ok = await confirmDialog({
      title: "Remote self-loop?",
      text: `Ask ${row.mobileNumber}'s phone to self-verify?`,
      note: "Free — no gateway SMS",
      confirmButtonText: "Send",
    });
    if (!ok.isConfirmed) return;
    try {
      await UserDetailsService.selfLoopUser(row.id);
      toastMsg("success", `Self-loop pushed to ${row.mobileNumber}`);
      getAllUser(); // icon turns green right away
    } catch (e) {
      toastMsg("danger", e?.response?.data?.apierror?.message || "Self-loop failed");
    }
  };

  // Bulk cross: every UNVERIFIED user matching the current filters (max 50/click, skips recent).
  const bulkCross = async () => {
    setCrossBusy(true);
    try {
      const pre =
        (await UserDetailsService.crossByFilter(crossFilters(), true))?.data?.apiresponse?.data || {};
      if (!pre.toSend) {
        toastMsg("info", `No unverified users to cross (skipped ${pre.skipped ?? 0})`);
        return;
      }
      const ok = await confirmDialog({
        title: "Bulk cross-check?",
        text:
          `Send a verification SMS to ${pre.toSend} unverified user(s)? (${pre.toSend} gateway SMS)` +
          (pre.skipped ? ` — ${pre.skipped} skipped (sent < 10 min ago).` : "") +
          (pre.capped ? " Limited to 50 per click." : ""),
        confirmButtonText: "Send",
        danger: true,
      });
      if (!ok.isConfirmed) return;
      const res =
        (await UserDetailsService.crossByFilter(crossFilters(), false))?.data?.apiresponse?.data || {};
      toastMsg("success", `Sending ${res.toSend ?? 0} · skipped ${res.skipped ?? 0}`);
    } catch (e) {
      toastMsg("danger", "Bulk cross failed");
    } finally {
      setCrossBusy(false);
    }
  };

  return (
    <>
      <h5 className="text-lg font-semibold dark:text-white-light mb-3">
        User Details
      </h5>

      {/* <DateRangePicker
        initialSettings={{ startDate: "09/01/2024", endDate: "10/01/2024" }}
        // renges={selectionRange}
        // onchange={handleSelect}
      >
        <button className="border-2 rounded-md p-2">Select a Date</button>
      </DateRangePicker> */}
      {/* ONE row: filters (flex) · bulk actions · Clear on the far right. Small (h-8, text-xs). */}
      <div className="allfilter flex items-center gap-1.5 w-full mb-4">
        <div className="flex-1 min-w-[100px]">
          <input
            type="number"
            placeholder="Mobile Number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            className="w-full h-8 border border-gray-300 rounded-md px-2 text-xs"
          />
        </div>
        <input
          type="date"
          title="Installed from"
          value={date}
          max={dateTo || undefined}
          onChange={handleDateChange}
          className="w-[118px] shrink-0 h-8 border border-gray-300 rounded-md px-1.5 text-xs"
        />
        <span className="text-xs text-gray-500 shrink-0">to</span>
        <input
          type="date"
          title="Installed to"
          value={dateTo}
          min={date || undefined}
          onChange={handleDateToChange}
          className="w-[118px] shrink-0 h-8 border border-gray-300 rounded-md px-1.5 text-xs"
        />

        {countryOptions.length > 0 && (
          <div className="dropdown flex-1 min-w-[90px]">
            <DropdownCustom
              data={countryOptions}
              setData={setSelectedCountry}
              name="Country Name"
              compact
              selectedValue={selectedCountry}
            />
          </div>
        )}

        <div className="dropdown flex-1 min-w-[90px]">
          <DropdownCustom
            data={[
              { label: "All", value: "" },
              { label: "Online", value: "true" },
              { label: "Offline", value: "false" },
            ]}
            setData={setIsOnline}
            name="Status"
            compact
            selectedValue={isOnline}
          />
        </div>

        <div className="dropdown flex-1 min-w-[90px]">
          <DropdownCustom
            data={[
              { label: "All", value: "" },
              { label: "Verified", value: "true" },
              { label: "Unverified", value: "false" },
            ]}
            setData={setVerified}
            name="Verification"
            compact
            selectedValue={verified}
          />
        </div>

        <div className="dropdown flex-1 min-w-[90px]">
          <DropdownCustom
            data={[
              { label: "All", value: "" },
              { label: "From SIM", value: "true" },
              { label: "Typed", value: "false" },
            ]}
            setData={setFromSim}
            name="Number source"
            compact
            selectedValue={fromSim}
          />
        </div>

        {mccData.length > 0 && (
          <div className="dropdown flex-1 min-w-[90px]">
            <DropdownCustom
              data={mccData}
              setData={setSelectedMCC}
              name="MCC"
              compact
              selectedValue={selectedMCC}
            />
          </div>
        )}

        {mncData.length > 0 && (
          <div className="dropdown flex-1 min-w-[90px]">
            <DropdownCustom
              data={mncData}
              setData={setSelectedMNC}
              name="MNC"
              compact
              selectedValue={selectedMNC}
            />
          </div>
        )}

        {/* Bulk-wake every device matching the CURRENT filters (same filters shown above). */}
        <button
          type="button"
          disabled={bulkBusy}
          onClick={bulkNotify}
          className="shrink-0 h-8 bg-primary/90 hover:bg-primary text-white rounded-md px-3 text-xs font-semibold whitespace-nowrap disabled:opacity-50"
          title="Wake all devices matching the current filters"
        >
          {bulkBusy ? "Notifying…" : "Bulk Notify"}
        </button>

        {/* Bulk cross-check every UNVERIFIED device matching the current filters (max 50/click). */}
        <button
          type="button"
          disabled={crossBusy}
          onClick={bulkCross}
          className="shrink-0 h-8 border border-rose-300 text-rose-600 hover:bg-rose-500/10 rounded-md px-3 text-xs font-semibold whitespace-nowrap disabled:opacity-50"
          title="Send a verification SMS to all unverified users matching the current filters"
        >
          {crossBusy ? "Crossing…" : "Bulk Cross"}
        </button>

        <button
          type="button"
          onClick={handleClearFilters}
          className="shrink-0 h-8 border border-gray-300 text-gray-600 rounded-md px-3 text-xs font-semibold whitespace-nowrap hover:bg-gray-100"
          title="Clear all filters"
        >
          Clear
        </button>
      </div>

      <div className="overflow-x-auto">
        <DataTable
          noRecordsText="No results match your search query"
          highlightOnHover
          className="whitespace-nowrap table-hover"
          records={data}
          columns={[
            {
              accessor: "id",
              title: "ID",
              // sortable: true,
              render: ({ id }, index) => (
                <div>
                  <span>{(page - 1) * pageSize + index + 1}</span>
                </div>
              ),
            },
            {
              accessor: "mobileNumber",
              title: "Mobile No.",
              render: ({ mobileNumber, simNumber }) => (
                <div className="flex items-center gap-1">
                  <span className="!text-xs">{mobileNumber}</span>
                  {simNumber ? (
                    <span
                      title={`Read from SIM: ${simNumber}`}
                      className="text-[10px] font-bold text-sky-600 bg-sky-500/15 rounded px-1 py-0.5"
                    >
                      SIM
                    </span>
                  ) : null}
                </div>
              ),
            },
            {
              accessor: "countryCode",
              title: "ISO",
              render: ({ countryCode }) => (
                <div className="">
                  <span className="!text-xs">{countryCode}</span>
                </div>
              ),
            },
            {
              accessor: "country",
              title: "Country Name",
              render: ({ country }) => {
                // Backend stores `country` as the ISO code (e.g. "IL"); map it to the full
                // name for display, falling back to the raw value if not found.
                const name =
                  CountriesJSON.find(
                    (c) =>
                      String(c.value).toUpperCase() ===
                      String(country).toUpperCase()
                  )?.label || country;
                return (
                  <div className="">
                    <span className="!text-xs">{name}</span>
                  </div>
                );
              },
            },
            {
              accessor: "mcc",
              title: "MCC",
              render: ({ mcc }) => (
                <div className="">
                  <span className="!text-xs">{mcc !== null ? mcc : "-"}</span>
                </div>
              ),
            },
            {
              accessor: "mnc",
              title: "MNC",
              render: ({ mnc }) => (
                <div className="">
                  <span className="!text-xs">{mnc !== null ? mnc : "-"}</span>
                </div>
              ),
            },
            {
              accessor: "networkName",
              title: "Mobile Network Name",
              render: ({ networkName }) => (
                <div className="">
                  <span className="!text-xs">{networkName}</span>
                </div>
              ),
            },
            {
              accessor: "creationDate",
              title: "Installation Date",
              // Latest install (a reinstall counts as a new install); hover shows the FIRST sign-up.
              render: ({ creationDate, installedAt }) => {
                const ok = (v) => v !== null && v !== undefined && v !== "" && v !== "null" && Number(v) > 0;
                const shown = ok(installedAt) ? installedAt : creationDate;
                const fmt = (v) => moment(Number(v)).format("DD/MM/YYYY HH:mm");
                const reinstalled = ok(installedAt) && ok(creationDate) && fmt(installedAt) !== fmt(creationDate);
                return (
                  <div title={ok(creationDate) ? `First signed up: ${fmt(creationDate)}` : undefined}>
                    <span className="!text-xs">{ok(shown) ? fmt(shown) : "--"}</span>
                    {reinstalled && <span className="ml-1 text-[10px] text-slate-400">↻</span>}
                  </div>
                );
              },
            },
            {
              accessor: "lastActiveDate",
              title: "Last Active Date",
              render: ({ lastActiveDate }) => (
                <div className="">
                  <span className="!text-xs">
                    {lastActiveDate !== "0" &&
                    lastActiveDate !== 0 &&
                    lastActiveDate !== "" &&
                    lastActiveDate !== null &&
                    lastActiveDate !== undefined &&
                    lastActiveDate !== "null"
                      ? moment(Number(lastActiveDate)).format(
                          "DD/MM/YYYY HH:mm"
                        )
                      : "--"}
                  </span>
                </div>
              ),
            },
            {
              accessor: "isOnline",
              title: "Status",
              render: ({ isOnline }) => (
                <div>
                  <span
                    className={`${
                      isOnline
                        ? "text-success bg-success/15"
                        : "text-danger bg-danger/10"
                    } rounded px-2 py-0.5 text-xs w-fit font-bold`}
                  >
                    {isOnline ? "Online" : "Offline"}
                  </span>
                </div>
              ),
            },
            {
              accessor: "verified",
              title: "Verified",
              render: ({ verified }) => (
                <div>
                  <span
                    className={`${
                      verified
                        ? "text-success bg-success/15"
                        : "text-slate-500 bg-slate-400/15"
                    } rounded px-2 py-0.5 text-xs w-fit font-bold`}
                  >
                    {verified ? "Verified" : "Unverified"}
                  </span>
                </div>
              ),
            },
            {
              accessor: "notify",
              title: "Action",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <button
                    type="button"
                    onClick={() => sendNotification(row.id)}
                    title="Notify — wake the device"
                    className="p-1.5 rounded-md text-primary hover:bg-primary/10 transition-colors"
                  >
                    <FiBell size={16} />
                  </button>
                  <button
                    type="button"
                    onClick={() => selfLoopOne(row)}
                    title={
                      row.lastSelfLoopAt
                        ? `Remote self-loop sent ${moment(Number(row.lastSelfLoopAt)).format("DD/MM HH:mm")} — click to send again (free)`
                        : "Remote self-loop — free, re-verify via the device's own SIM"
                    }
                    className={`p-1.5 rounded-md transition-colors hover:bg-emerald-500/10 ${
                      row.lastSelfLoopAt
                        ? "text-emerald-600"
                        : "text-slate-400 hover:text-emerald-600"
                    }`}
                  >
                    <FiRefreshCw size={16} />
                  </button>
                  <button
                    type="button"
                    onClick={() => crossOne(row)}
                    title="Cross-check — paid verification SMS"
                    className="p-1.5 rounded-md text-rose-500 hover:bg-rose-500/10 transition-colors"
                  >
                    <FiSend size={16} />
                  </button>
                </div>
              ),
            },
          ]}
          totalRecords={totalData}
          recordsPerPage={pageSize}
          onPageChange={(p) => setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={(size) => {
            setPageSize(Number(size) || 10);
            setPage(1);
          }}
          minHeight={200}
          loading={isLoading}
          fetching={isLoading}
        />
      </div>
      <div className="flex mt-4 items-end">
        {/* <div>Previous</div> */}
        <CustomPagination
          total={totalData}
          page={page}
          handleChange={handleChange}
          dataPerPage={pageSize}
          handleDataPerPage={handleDataPerPage}
          PAGE_SIZES={PAGE_SIZES}
        />
        {/* <div>Next</div> */}
      </div>

      {confirmState && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px]"
            onClick={() => closeConfirm(false)}
          />
          <div className="relative w-full max-w-sm rounded-2xl bg-white dark:bg-[#1b2e4b] p-6 shadow-2xl ring-1 ring-black/5 dark:ring-white/10">
            <h3 className="text-base font-semibold text-slate-800 dark:text-white">
              {confirmState.title}
            </h3>
            {confirmState.text && (
              <p className="mt-2 text-sm leading-relaxed text-slate-500 dark:text-slate-300">
                {confirmState.text}
              </p>
            )}
            {confirmState.note && (
              <p className="mt-1 text-xs text-slate-400">{confirmState.note}</p>
            )}
            <div className="mt-6 flex justify-end gap-2">
              <button
                type="button"
                onClick={() => closeConfirm(false)}
                className="rounded-lg px-4 py-2 text-sm font-medium bg-slate-100 text-slate-600 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600 transition-colors"
              >
                {confirmState.cancelButtonText || "Cancel"}
              </button>
              <button
                type="button"
                autoFocus
                onClick={() => closeConfirm(true)}
                className={`rounded-lg px-4 py-2 text-sm font-medium text-white transition-colors ${
                  confirmState.danger
                    ? "bg-rose-600 hover:bg-rose-700"
                    : "bg-primary hover:opacity-90"
                }`}
              >
                {confirmState.confirmButtonText || "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UserDetails;
// min-w-[1200px] max-w-[1200px] flex justify-between items-end
